import { call } from '@advanza/api'
import InputField from '@trustoo/components/input/InputField'
import LoginBox from '@trustoo/components/login/LoginBox'
import LoginButton from '@trustoo/components/login/LoginButton'
import { useEnterKeyPress } from '@trustoo/hooks/useEnterKeyPress'
import { getLogoUrls } from '@trustoo/utils/localeUtils'
import LoginError from 'components/login/LoginError'
import { getRedirectAfterLogin, LoginResponse } from 'components/login/redirectAfterLogin'
import { useState } from 'react'
import { Navigate } from 'react-router-dom'

const getError = (response: { error?: string }) => response.error ?? 'Something went wrong'

const TwoFactorOneTimeCode = () => {
    const [code, setCode] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const [redirect, setRedirect] = useState('')
    const [error, setError] = useState('')

    const checkTwoFactorCode = () => {
        setIsLoading(true)
        setError('')
        call('auth/check-two-factor-code', { json: { code } })
            .then(
                (response: { redirect?: string }) =>
                    response.redirect
                        ? setRedirect(response.redirect)
                        : call('auth/login', { method: 'post' }).then(
                              (loginResponse: LoginResponse) =>
                                  setRedirect(getRedirectAfterLogin(loginResponse)),
                              (loginResponse: { error?: string }) =>
                                  setError(getError(loginResponse)),
                          ),
                (response: { error?: string }) => setError(getError(response)),
            )
            .finally(() => setIsLoading(false))
    }

    useEnterKeyPress(checkTwoFactorCode, code !== '' && !isLoading)

    if (redirect) {
        return <Navigate to={redirect} replace />
    }

    return (
        <LoginBox
            title="Two-factor authentication"
            logoUrl={getLogoUrls().default}
            isLoading={isLoading}>
            <div className="flex flex-col gap-4 pt-4">
                <h2 className="m-0 text-lg">One-time code</h2>
                <p className="m-0">
                    Generate and enter code from Google Authenticator (or similar app like FreeOTP):
                </p>
                <InputField
                    name="code"
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                    inputMode="numeric"
                    autoComplete="one-time-code"
                    autoFocus
                />
                {error && <LoginError message={error} />}
                <LoginButton
                    onClick={checkTwoFactorCode}
                    disabled={code === '' || isLoading}
                    className="w-full">
                    Submit
                </LoginButton>
            </div>
        </LoginBox>
    )
}

export default TwoFactorOneTimeCode
